export const datadogStartRUM = (email: string) => {
    if (!window.DD_RUM) return; // not enabled

    if (email) {
        window.DD_RUM.setUserProperty('email', email);
    }

    window.DD_RUM.startSessionReplayRecording();
};

export const datadogStopRUM = () => {
    if (!window.DD_RUM) return; // not enabled

    window.DD_RUM.stopSessionReplayRecording();
};
